import Config from '../../config';
import Collection from '../../collection';
import Field from '../../model/refbooks/field';
import { FieldForm } from '../../view/module/refbooks/fields.form.popup';
import Grid from '../../view/grid';
import Model from '../../model/model';
import Template from './types.form.template';

import { roleA, roleC } from '../../roles';
import { hashify } from '../../utils/arrays';
import { pick } from '../../utils/popups';
import { subtract } from '../../utils/collections';





export default Template.extend( {

    template: 'module/refbooks/types.form.bound-fields',

    url() {
        return this.options.type.id
            ? `types/${this.options.type.id}/edit/bound-fields`
            : `types/new/bound-fields`;
    },

    finalizeOpen(type, { originalCluster }) {
        const {
            fieldsPage = 1, fieldsLimit = 10,
            fieldsSort = 'order', fieldsDirection = 'asc',
            fieldsSearch = '',
            systemFieldsMode = localStorage['talitrum.types.filters.system-fields-mode'] || 'non-system',
            rolesVisiblePage = 1, rolesVisibleLimit = 10,
            rolesVisibleSort = 'name', rolesVisibleDirection = 'asc',
            rolesEditablePage = 1, rolesEditableLimit = 10,
            rolesEditableSort = 'name', rolesEditableDirection = 'asc',
            rolesMode = 'VISIBILITY',
        } = this.state() || {};

        this.setState( { 
            fieldsPage, fieldsLimit, fieldsSort, fieldsDirection, fieldsSearch,
            systemFieldsMode,
            rolesVisiblePage, rolesVisibleLimit, rolesVisibleSort, rolesVisibleDirection,
            rolesEditablePage, rolesEditableLimit, rolesEditableSort, rolesEditableDirection,
            rolesMode,
        } );

        this.options.rolesVisibleSorted = new Collection();
        this.options.rolesVisibleFiltered = new Collection();
        this.options.rolesVisibleResulted = new Collection();
        this.options.rolesEditableSorted = new Collection();
        this.options.rolesEditableFiltered = new Collection();
        this.options.rolesEditableResulted = new Collection();

        const binding = this.reSortGrid().then( () => Promise.all( [this.reSortRolesVisibleGrid(), this.reSortRolesEditableGrid()] ) )
            .then( () => {
                // hack to allow reFilterGrid work
                // TODO remove this hack
                this.model = type;
                this.reFilterGrid();
                // TODO
                this.reFilterRolesVisibleGrid();
                this.reFilterRolesEditableGrid();
                this.model = undefined;
            } )
            .then( () => this.bind( type ) )
            .then( () => this.originalModel.set( 'cluster', originalCluster ) )
            .then( () => this );
        return binding.view = this, binding;
    },

    setState(state = {}) {
        if ('systemFieldsMode' in state)
            localStorage['talitrum.types.filters.system-fields-mode'] = state['systemFieldsMode'];

        return Template.prototype.setState.call( this, state );
    },

    onBind() {
        Template.prototype.onBind.call( this );

        this.listenTo( this.options.resulted, 'activate deactivate',
            () => this.FieldButtons && this.FieldButtons.render() );
    },

    serialize() {
        const { 
            fieldsSort, fieldsDirection, fieldsSearch, 
            rolesVisibleSort, rolesVisibleDirection,
            rolesEditableSort, rolesEditableDirection
        } = this.state();

        const { 
            resulted: fields, 
            rolesVisibleFiltered, rolesVisibleResulted, 
            rolesEditableFiltered, rolesEditableResulted,
        } = this.options;

        return {
            ...Template.prototype.serialize.call( this ),
            // TODO in Template?
            rolesVisible: rolesVisibleFiltered,
            rolesEditable: rolesEditableFiltered,
            rows: fields, 
            rolesVisibleRows: rolesVisibleResulted,
            rolesEditableRows: rolesEditableResulted,

            fieldsSearch, fieldsSort, fieldsDirection,
            rolesVisibleSort, rolesVisibleDirection,
            rolesEditableSort, rolesEditableDirection,

            rolesMode: () => this.state().rolesMode,

            ['system-fields-mode']: () =>
                this.state().systemFieldsMode,

            currentField: () =>
                fields.current(),

            currentVisibleRoles: () =>
                findVisibleRoles( fields.current(), this.model, this.options ),

            currentEnabledRoles: () =>
                // no matter, visible or editable
                enabledRoleIds( fields.current(), this.options.rolesVisibleFiltered ),

            currentEditableRoles: () =>
                findEditableRoles( fields.current(), this.model, this.options ),

            visibleByDefaultToggled: () => {
                const rule = currentRule( fields.current(), this.model, this.options.bindings );
                return [true, 't'].includes( rule.visible_by_default );
            },
    
            editableByDefaultToggled: () => {
                const rule = currentRule( fields.current(), this.model, this.options.bindings );
                if (rule)
                    if (rule.editable_by_default != null)
                        return [true, 't'].includes( rule.editable_by_default );

                return [true, 't'].includes( fields.current().get( 'editable_by_default' ) );
            },
    
        };
    },

    events: {

        'click .-sort'({currentTarget}) {
            const { sort, direction, } = currentTarget.dataset;

            if ( this.$( currentTarget ).closest( '[name="Grid"]' ).length)
                this.setState( { fieldsPage: 1, fieldsSort: sort, fieldsDirection: direction, } );
            if ( this.$( currentTarget ).closest( '[name="RolesVisibleGrid"]' ).length)
                this.setState( { rolesVisiblePage: 1, rolesVisibleSort: sort, rolesVisibleDirection: direction, } );
            if ( this.$( currentTarget ).closest( '[name="RolesEditableGrid"]' ).length)
                this.setState( { rolesEditablePage: 1, rolesEditableSort: sort, rolesEditableDirection: direction, } );

            let rendering;
            if (this.$( currentTarget ).closest( '[name="Grid"]' ).length)
                rendering = this.reSortGrid().then( () => this.reFilterGrid() );
            if ( this.$( currentTarget ).closest( '[name="RolesVisibleGrid"]' ).length)
                rendering = this.reSortRolesVisibleGrid().then( () => this.reFilterRolesVisibleGrid() );
            if ( this.$( currentTarget ).closest( '[name="RolesEditableGrid"]' ).length)
                rendering = this.reSortRolesEditableGrid().then( () => this.reFilterRolesEditableGrid() );

            return rendering
                    // hack: to rerender grid caption with order direction
                    .then( () => this.render() )
                    .then( () => this.navigated() );
        },

    },

    [Template.event( 'Paging:page')](page) {
        return this.setState( { fieldsPage: +page, } ),
            this.reFilterGrid( this ),
            this.navigated();
    },

    [Template.event( 'RolesVisiblePaging:page')](page) {
        return this.setState( { rolesVisiblePage: +page, } ),
            this.reFilterRolesVisibleGrid(),
            this.navigated();
    },

    [Template.event( 'RolesEditablePaging:page')](page) {
        return this.setState( { rolesVisiblePage: +page, } ),
            this.reFilterRolesVisibleGrid(),
            this.navigated();
    },

    [Template.event( 'Search:search')](fieldsSearch) {
        return this.setState( { fieldsSearch, fieldsPage: 1, } ), 
            this.reFilterGrid( this ),
            this.navigated();
    },

    [Template.event( 'SystemFieldsMode:filter')](systemFieldsMode) {
        return this.setState( { systemFieldsMode, fieldsPage: 1, } ), 
            this.reFilterGrid(),
            this.SystemFieldsMode.render(),
            this.navigated();
    },

    [Template.event( 'FieldButtons:fields:new Grid:action:create')]() {
        // take into account whether button is disabled or not
        if (this.$( '.--field-new[disabled]' ).length)
            return;

        createField( this.model, this.options.bindings, this.options )
            .then( () => this.reSortGrid() ).then( () => this.reFilterGrid() )
            .then( () => this.Buttons.render() );
    },

    [Template.event( 'FieldButtons:fields:edit Grid:action:default')]() {
        // take into account whether button is disabled or not
        if (this.$( '.--field-edit[disabled]' ).length)
            return;

        updateField( this.model, this.options.resulted.current(), this.options.bindings, this.options )
            .then( () => this.reSortGrid() ).then( () => this.reFilterGrid() )
            .then( () => this.Buttons.render() );
    },

    [Template.event( 'FieldButtons:fields:detach Grid:action:destroy')]() {
        // take into account whether button is disabled or not
        if (this.$( '.--field-detach[disabled]' ).length)
            return;

        removeBinding( this.options.resulted.current(), this.options.bindings )
            .then( () => {
                const { length } = this.options.resulted;
                const { fieldsPage, } = this.state();
                if (length === 1 && fieldsPage > 1)
                    this.setState( { fieldsPage: fieldsPage - 1 } ),
                    this.navigated();
            } )
            .then( () => this.reSortGrid() ).then( () => this.reFilterGrid() )
            .then( () => this.Buttons.render() );
    },

    [Template.event( 'FieldButtons:fields:choose' )]() {
        const available = availableFields( this.options, 
            field => 
                [false, 'f'].includes( field.system ) &&
                [false, 'f'].includes( field.is_for_all ) );
        const hash = hashify( available, field => [field.id, field] );

        const selected = boundFields( available, this.options )
            .toJSON();

        pick( selected, 
            {   collection: available,
                cluster: this.options.type.get( 'cluster' ),
                idOnly: false,
                fullCollection: true } )
            .then( newSelected => [
                subtract( newSelected, selected ), 
                subtract( selected, newSelected )] )
            .then( ([add, rem]) => [
                add.map( f => hash[f.id] ),
                rem.map( f => hash[f.id] ),
            ] )
            .then( ([add, rem]) => {
                const { bindings } = this.options;
                add.forEach( field => updateBinding( this.options.type, field /* with bindings */, bindings, true ) );
                rem.forEach( field => removeBinding( field, bindings ) );
            } )
            .then( () => this.reSortGrid() ).then( () => this.reFilterGrid() )
            .then( () => this.Buttons.render() );
    },

    [Template.event( 'Grid:activate' )](index, field) {
        this.setState( { 
            rolesVisiblePage: 1, rolesEditablePage: 1, 
            fieldsActiveId: field.id,
        } );
        this.reFilterRolesVisibleGrid();
        this.reFilterRolesEditableGrid();
        this.Roles.render();
        this.navigated();
    },

    [Template.event( 'Grid:deactivate' )]() {
        this.setState( { 
            fieldsActiveId: undefined,
        } );
        this.Roles.render();
        this.navigated();
    },

    [Template.event( 'RolesVisibleGrid:role:toggle' )](id) {
        handleToggleRole.call( this,
            id,
            toggleRoleVisible, findVisibleRoles,
            this.$( '[name=RolesVisibleGrid] thead [type=checkbox]' ) );
    },

    [Template.event( 'RolesEditableGrid:role:toggle' )](id) {
        handleToggleRole.call( this,
            id,
            toggleRoleEditable, findEditableRoles,
            this.$( '[name=RolesEditableGrid] thead [type=checkbox]' ) );
    },

    [Template.event( 'RolesVisibleGrid:role:toggle-all' )]() {
        handleToggleAllRoles.call( this,
            toggleRoleVisible, findVisibleRoles,
            this.$( '[name=RolesVisibleGrid] tbody [type=checkbox]:not([disabled])' ) );
    },

    [Template.event( 'RolesEditableGrid:role:toggle-all' )]() {
        handleToggleAllRoles.call( this,
            toggleRoleEditable, findEditableRoles,
            this.$( '[name=RolesEditableGrid] tbody [type=checkbox]:not([disabled])' ) );
    },

    [Template.event( 'Roles:visible-by-default:toggle' )]() {
        handleToggleByDefault.call( this,
            toggleRoleVisible, findVisibleRoles,
            'visible_by_default' );
    },

    [Template.event( 'Roles:editable-by-default:toggle' )]() {
        handleToggleByDefault.call( this,
            toggleRoleEditable, findEditableRoles,
            'editable_by_default' );
    },

    [Template.event( 'Roles:mode:set' )](rolesMode) {
        return this.setState( { rolesMode, } ), 
            this.navigated(),
            this.Roles.render();
    },
    
    reSortGrid() {
        const { fieldsSort, fieldsDirection: direction, } = this.state();

        const sort = fieldsSort !== 'order' 
            ? fieldsSort
            : model => {
                // "norder" - fake order for new fields on client side, 
                // it isn't sent to server;
                // contains big values to force putting new fields into the end of list
                const order = +model.order || +model.norder;
                if ([true, 't'].includes( model.system ))
                    return -1000000000000 + order;
                else if (!model.cluster )
                    return -1000000000 + order;
                else
                    return +order;
            };

        return Grid.sort( { sort, direction }, 
            availableFields( this.options ), 
            this.options.sorted, )
    },

    reFilterGrid() {
        const { 
            fieldsPage: page, fieldsSearch: search, fieldsLimit: limit,
            fieldsActiveId: activeId, } = this.state();
        const { type, sorted, filtered, resulted, } = this.options;

        Grid.filter( { page, search, limit, activeId, },
            type.get( 'cluster' ), 
            boundFields( sorted, this.options ), filtered, resulted,
            // filter by system/non-system-all toggle
            field => 
                [true, 't'].includes( field.get( 'system' ) ) && this.state().systemFieldsMode != 'non-system' ||
                [false, 'f'].includes( field.get( 'system' ) ) && this.state().systemFieldsMode != 'only-system' );
    },

    reSortRolesVisibleGrid() {
        const { rolesVisibleSort: sort, rolesVisibleDirection: direction } = this.state();
        const { roles, rolesVisibleSorted, } = this.options;

        return Grid.sort( { sort, direction, }, roles, rolesVisibleSorted )
    },

    reSortRolesEditableGrid() {
        const { rolesEditableSort: sort, rolesEditableDirection: direction } = this.state();
        const { roles, rolesEditableSorted, } = this.options;

        return Grid.sort( { sort, direction, }, roles, rolesEditableSorted )
    },

    reFilterRolesVisibleGrid() {
        const { rolesVisiblePage: page, rolesVisibleLimit: limit, } = this.state();
        const { resulted } = this.options;
        const { rolesVisibleSorted, rolesVisibleFiltered, rolesVisibleResulted } = this.options;

        Grid.filter( { page, limit }, 
            this.model.get( 'cluster' ) || resulted.current() && resulted.current().get( 'cluster' ),
            rolesVisibleSorted, rolesVisibleFiltered, rolesVisibleResulted );
    },
    
    reFilterRolesEditableGrid() {
        const { rolesEditablePage: page, rolesEditableLimit: limit, } = this.state();
        const { resulted } = this.options;
        const { rolesEditableSorted, rolesEditableFiltered, rolesEditableResulted } = this.options;

        Grid.filter( { page, limit }, 
            this.model.get( 'cluster' ) || resulted.current() && resulted.current().get( 'cluster' ),
            rolesEditableSorted, rolesEditableFiltered, rolesEditableResulted );
    },
    
} );





function makeNewRule() {
    return {
        visible_by_default: true,
        visible_inverted_for_roles: [],
        editable_by_default: null,
        editable_inverted_for_roles: null,
    }
}

function availableFields({ fields, bindings: { add, update } }, predicate = () => true) {
    return [
        ...fields.toJSON()
            // maybe in updated bindings, maybe in new-added bindings...
            .map( f => update[f.id] ? update[f.id].field 
                : add[f.id] ? add[f.id].field : f ), 
        ...Object.values( add )
            // only new-created
            .filter( b => b.field.id < 0 && [false, 'f'].includes( b.field.system ) )
            .map( b => b.field ) 
    ].filter( predicate );
}

function boundFields(source, { type, fields, bindings: { add, update, remove } }) {
    if (source instanceof Collection)
        source = source.toJSON();
    if (!(source instanceof Array))
        source = Object.values( source );

    const hasBinding = hashify( fields
        .models
        .filter( field => 
            // check up "new" bindings (maybe there are "on"=true)
            update[field.id] && [true, 't'].includes( update[field.id].on ) ||

            // and also go through "old" bindings
            (field.get( 'bindings' ) || []).find( binding =>
                [true, 't'].includes( binding.on ) && +binding.type.id == +type.id ) )
        .map( field => field.id ) );

    return new Collection( source
        .filter( field => !remove[field.id])
        .filter( field =>  
            // old "for all" fields
            [true, 't'].includes( field.is_for_all ) ||
            // old-bound fields
            hasBinding[field.id] ||
            // new-bound fields
            add[field.id] ), 
        { /* Collection's options */ } );
}

function handleToggleAllRoles(toggleFn, findRolesFn, $checkboxes) {
    const field = this.options.resulted.current();
    const idsBefore = hashify( findRolesFn( 
        field,
        this.model, this.options ) );
    const checkedBeforeClick = 
        // достаточно поискать список доступых ролей в rolesVisibleFiltered - 
        // результат будет совпадать с поиском по rolesEditableFiltered
        enabledRoleIds( field, this.options.rolesVisibleFiltered )
            .every( roleId => idsBefore[roleId] );
    const checkedAfterClick = !checkedBeforeClick;

    enabledRoleIds( field, this.options.rolesVisibleFiltered )
        .filter( id => checkedAfterClick && !idsBefore[id] || !checkedAfterClick && idsBefore[id] )
        .forEach( id => toggleFn( field, this.model, id, checkedAfterClick, this.options ) );

    $checkboxes.toArray()
        .forEach( el => el.checked = checkedAfterClick );

    this.Buttons.render();
}

function handleToggleRole(id, toggleFn, findRolesFn, $allCheckbox) {
    const field = this.options.resulted.current();
    const idsBefore = findRolesFn( 
        field, 
        this.model, this.options );
    const checkedBeforeClick = idsBefore.includes( +id ) || idsBefore.includes( '' + id );
    const checkedAfterClick = !checkedBeforeClick;

    toggleFn( 
        field, this.model,
        id, checkedAfterClick,
        this.options, );

    const idsAfter = hashify( findRolesFn( 
        field, 
        this.model, this.options ) );
    $allCheckbox[0].checked = 
        // достаточно поискать список доступых ролей в rolesVisibleFiltered - 
        // результат будет совпадать с поиском по rolesEditableFiltered
        enabledRoleIds( field, this.options.rolesVisibleFiltered )
            .every( roleId => idsAfter[roleId] );

    this.Buttons.render();
}

function handleToggleByDefault(toggleFn, findRolesFn, propCheckboxName) {
    const field = this.options.resulted.current();
    const idsBefore = hashify( findRolesFn( 
        field,
        this.model, this.options ) );

    // if "by default" enabled, then all roles in Grid are available
    enabledRoleIds( field, this.options.rolesVisibleFiltered )
        .forEach( id => toggleFn( field, this.model, id, !idsBefore[id], this.options, ));

    // toggleRole called, so there is Rule now
    const rule = currentRule( field, this.model, this.options.bindings );
    rule[propCheckboxName] = ['f', false].includes( rule[propCheckboxName] != null
        ? rule[propCheckboxName]
        : field.get( propCheckboxName ) );

    this.Buttons.render();
}

function toggleRoleVisible(field, type, id, checked, options) {
    return toggleRole(
        field, type,
        id, checked,
        options,
        'visible_by_default', 'visible_inverted_for_roles' );
}

function toggleRoleEditable(field, type, id, checked, options) {
    return toggleRole(
        field, type,
        id, checked,
        options,
        'editable_by_default', 'editable_inverted_for_roles' );
}

function toggleRole(field, type, id, checked, { bindings: { add, update, remove, } }, propCheckboxName, propArrayName) {
    const binding = currentBinding( field, type, { add, update, remove,}, true );

    // if (!binding.rules || !binding.rules.length)
    //     binding.rules = [{ visible_by_default: true, visible_inverted_for_roles: [] }];

    const [rule] = binding.rules;
    const checkboxValue = [true, 't'].includes( rule[propCheckboxName] != null
        ? rule[propCheckboxName]
        : field.get( propCheckboxName ) );
    const arrayValue = rule[propArrayName] != null
        ? rule[propArrayName]
        : field.get( propArrayName );
    
    rule[propCheckboxName] = checkboxValue;
    rule[propArrayName] = checked ^ checkboxValue
        ? [...arrayValue, +id]
        : arrayValue.filter( roleId => roleId != id );
}

function enabledRoleIds(field, roles) {
    const models = roles instanceof Collection
        ? roles.models
        : roles;

    return models
        // ignore unavailable (disabled) checkboxes
        .filter( model => 
            // chief admin may check any MODEL
            // (local MODELS of wrong cluster do not pass filtration)
            roleA.includes( Config.role() ) ||
            // local MODELS may be checked anyway
            // (local MODELS of wrong cluster do not pass filtration)
            model.get( 'cluster' ) ||
            // local field may be joined to any MODEL
            // (local MODEL of wrong cluster do not pass filtration)
            field.get( 'cluster' ) )
        .map( model => model.id );
}

function createField(type, { add, update, remove }, { datatables, types, stickers, roles }) {
    // is_for_all == 'f'
    const { /*bindings, */cluster } = type.toJSON();
    const field = new Field( { /*bindings, */cluster } );

    const modal = FieldForm.popup( field, 
        {
            popupLabel: 'field::actions - new', applyLabel: 'actions::add', 
            level: 0 }, 
        { datatables, types, stickers, roles } );

    return modal
        .then( field => field.toJSON() )
        .then( ({ ...json, bindings }) => 
               ({ ...json, 
                    id: Math.min( -1000000, ...Object.values( add ).map( b => b.field.id ) ) - 1,
                    norder: Math.max( 1000000, ...Object.values( add ).map( b => b.field.norder ) ) + 1 }) )
        .then( json => 
            updateBinding( type, json /* no bindings */, { add, update, remove } ) );
}

function updateField(type, f, { add, update, remove }, { datatables, types, stickers, roles }) {
    // todo !!! cluster?
    const { /*bindings, */...json } = f.toJSON()
    const field = new Field( { /*bindings, */...json/* including cluster */ } );

    const boundToOtherTypes = 
        [true, 't'].includes( json.is_for_all ) || 
        json.bindings.find( b => b.type.id != type.id );

    const modal = FieldForm.popup( field, 
        { 
            popupLabel: 'actions::edit', applyLabel: 'actions::apply', 
            warning: boundToOtherTypes && 'type::label - field is bound to another types',
            level: 0 }, 
        { datatables, types, stickers, roles } );

    return modal.then( field => {
        const { ...json } = field.toJSON();

        if (add[json.id])
            return add[json.id].field = json;
        else if (update[json.id])
            return update[json.id].field = json;

        // todo do not add on/rules to binding automatically - it will cause server-binding-creating when just editing is-for-all-fields

        return updateBinding( type, json /* with bindings */, { add, update, remove } );
    } );
}

function removeBinding(field, { /*add, update, */remove }) {
    const json = field instanceof Model ? field.toJSON() : field;
    remove[json.id] = { field: { ...json } };

    return Promise.resolve();
}

function updateBinding(type, field, { add, update, remove }, addFlag = false) {
    const { ...json } = field instanceof Model ? field.toJSON(): field; 
    if (remove[field.id])
        return delete remove[field.id];

    const oldBinding = (json.bindings || []).find( b => b.type.id == type.id );
    if (!oldBinding)
        return add[json.id] = {
            field: { ...json }, 
            on: ['f', false].includes( json.is_for_all ),
            // todo
            rules: [makeNewRule()]
        };

    update[json.id] = {
        field: { ...json },
        on: addFlag ? true : oldBinding.on,
        rules: oldBinding.rules
            // todo
            .map( ({ visible_inverted_for_roles: v, editable_inverted_for_roles: e, ...b }) => 
                    ({ 
                        visible_inverted_for_roles: [...v], 
                        editable_inverted_for_roles: e != null ? [...e] : null,
                        ...b 
                    }) )
    };
}

function currentBinding(field, type, { add, update, remove }, allowCreateUpdate = false) {
    const json = field.toJSON();
    if (remove[json.id])
        return null;

    // will be false if removed; both new and old field may contain new binding in add
    const bindingAdd = add[json.id]
    const bindingUpd = update[json.id];

    const binding = bindingAdd || bindingUpd;
    if (binding)
        return binding;

    const bindingOld = field.get( 'bindings' )
        .find( binding => binding.type.id == type.id );
    if (!allowCreateUpdate)
        return bindingOld;

    const rules = bindingOld && bindingOld.rules;
    const bindingNew = {
        field: json,
        // binding is off for is-for-all-field
        on: ['f', false].includes( json.is_for_all ), 
        rules: rules && rules.length 
            ? rules.map( rule => 
                ({ 
                    id: rule.id,
                    visible_by_default: ['t', true].includes( rule.visible_by_default ), 
                    visible_inverted_for_roles: rule.visible_inverted_for_roles.map( i => +i ),
                    // todo
                    editable_by_default: rule.editable_by_default,
                    editable_inverted_for_roles: rule.editable_inverted_for_roles,
                }) )
            : [makeNewRule()]
    };

    // has binding? => update; no binding? => add
    if (bindingOld)
        return update[json.id] = bindingNew;
    else
        return add[json.id] = bindingNew;
}

function currentRule(field, type, { add, update, remove }) {
    // impossible case; copied from fields.form.types
    // if (!type)
    //     return null;

    const binding = currentBinding( field, type, { add, update, remove });

    // if (!binding)
    //     if ([true, 't'].includes( field.get( 'is_for_all') ))
    //         return binding || { visible_by_default: true, visible_inverted_for_roles: [] };
    //     else
    //         return null;
    if (!binding) // is for all
        return makeNewRule();

    // impossible case (field is always available to type in types.form.bound-fields if it is in Grid);
    // copied from fields.form.types, commented out
    // if (binding && ![undefined, true, 't'].includes( binding.on ))
    // if (![true, 't'].includes( field.get( 'is_for_all') ))
    //     return null;

    if (!binding.rules || !binding.rules.length)
        return makeNewRule();

    return binding.rules[0];
}

function findVisibleRoles(field, type, { roles, bindings, }) {
    const rule = currentRule( field, type, bindings );
    // impossible case; copied from fields.form.types
    // if (!rule)
    //     return [];

    const { visible_by_default, visible_inverted_for_roles, } = rule;
    return [false, 'f'].includes( visible_by_default )
        ? visible_inverted_for_roles
        : roles.toJSON()
            .map( role => +role.id )
            .filter( id => 
                !visible_inverted_for_roles.includes( id ) && 
                !visible_inverted_for_roles.includes( '' + id ) );
}

function findEditableRoles(field, type, { roles, bindings, }) {
    const rule = currentRule( field, type, bindings );
    // impossible case; copied from fields.form.types
    // if (!rule)
    //     return [];

    const { editable_by_default, editable_inverted_for_roles, } = rule;
    const editable = editable_by_default != null
        ? editable_by_default
        : field.get( 'editable_by_default' );
    const inverted_roles = editable_inverted_for_roles != null
        ? editable_inverted_for_roles
        : field.get( 'editable_inverted_for_roles' );

    return [false, 'f'].includes( editable )
        ? inverted_roles
        : roles.toJSON()
            .map( role => +role.id )
            .filter( id => !inverted_roles.includes( id ) && !inverted_roles.includes( '' + id ) );
}


// WEBPACK FOOTER //
// ./src/js/module/refbooks/types.form.bound-fields.js